define('viewModels/privileged/qm/AuditView',[
    'lib/knockout',
    'lib/lodash4',
    'jquery',
    'moment',
    'viewModels/ViewModel',
    'services/qualityManagementService',
    'services/qm/qualityAuth'
], function (
    ko,
    _,
    $,
    moment,
    ViewModel,
    qualityManagementService,
    qualityAuthorization
) {
    'use strict';

    var AuditView = ViewModel.extend(function (conversationId) {

        var self = this;

        self.auditGrid = ko.observable();
        self.selectedAuditEntityType = ko.observable(); //sets default to recording
        var COLUMNS = [
            {
                id: 'timestamp',
                label: 'interactions.audit.timestamp'
            },
            {
                id: 'action',
                label: 'interactions.audit.action'
            },
            {
                id: 'level',
                label: 'interactions.audit.level'
            },
            {
                id: 'status',
                label: 'interactions.audit.status'
            },
            {
                id: 'entityType',
                label: 'interactions.audit.entityType'
            },
            {
                id: 'user',
                label: 'interactions.audit.user'
            }
        ];

        self.gridOptions = ko.observable({
            pageCount: 1,
            pageNumber: 1,
            pageSize: 25
        });

        self.auditEntityTypeOptions = ko.observableArray((function(){
            var tempArray = [];
            if (qualityAuthorization.canViewRecordingAudit()){
                tempArray.push({text: ko.i18n.renderString('interactions.audit.entityType.RECORDING'), value: "RECORDING"});
            }
            if (qualityAuthorization.canViewAnnotationAudit()){
                tempArray.push({text: ko.i18n.renderString('interactions.audit.entityType.ANNOTATION'), value: "ANNOTATION"});
            }
            if (qualityAuthorization.canViewEvaluationAudit()){
                tempArray.push({text: ko.i18n.renderString('interactions.audit.entityType.EVALUATION'), value: "EVALUATION"});
                tempArray.push({text: ko.i18n.renderString('interactions.audit.entityType.CALIBRATION'), value: "CALIBRATION"});
            }

            if (tempArray.length > 0){
                self.selectedAuditEntityType(tempArray[0]);
            }

            return tempArray;
        })());

        if (qualityAuthorization.canViewScreenRecordingAudits()) {
            self.auditEntityTypeOptions.push({ text: ko.i18n.renderString('interactions.audit.entityType.SCREEN-RECORDING'), value: "SCREEN_RECORDING" });
        }

        self.refreshGrid = function(incomingOptions){
            var options = {};
            if (incomingOptions){
                options.pageNumber = incomingOptions.pageNumber;
                options.pageSize = incomingOptions.pageSize;
            }
            if (self.selectedAuditEntityType()){
                options.entityType = self.selectedAuditEntityType();
            }
            qualityManagementService.getAudits(conversationId, options)
                .then(function (response){
                    self.gridOptions({
                        pageCount: response.pageCount,
                        pageNumber: response.pageNumber,
                        pageSize: response.pageSize
                    });

                    var rows = _.map(response.entities, function(auditData){
                        var userName = "";
                        if (auditData.user){
                            userName = auditData.user.name;
                        }
                        return {
                            'timestamp':  new Date(auditData.timestamp),
                            'action': ko.i18n.renderString('interactions.audit.actions.' + auditData.action),
                            'level': ko.i18n.renderString('interactions.audit.level.' + auditData.level),
                            'status': ko.i18n.renderString('interactions.audit.status.' + auditData.status),
                            'entityType': ko.i18n.renderString('interactions.audit.entityType.' + auditData.entityType),
                            'user': userName
                        };
                    });
                    self.auditGrid().rows(rows);
                });
        };

        self.auditGrid({
            columns: COLUMNS,
            rows: ko.observableArray([]),
            dataOptions: self.gridOptions,
            onDataOptionsChange: self.refreshGrid
        });

        self.refreshGrid(self.gridOptions());
    });

    return AuditView;
});

